var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hold-transition sidebar-mini layout-fixed"},[_c('div',{staticClass:"wrapper"},[_c('layout-header'),_c('layout-sidebar'),_c('div',{staticClass:"content-wrapper"},[_c('router-view')],1),_c('layout-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }